(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hide-header-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function adjustHeader() {
    var logingButton = document.querySelector('.show__modal-login.header-top__link');
    var registerButton = document.querySelector('.show__modal-apply.header-top__link');
    var searchBar = document.querySelector('header div.top_header_search');
    var navGroup = document.querySelector('header div.nav-tab-group.shrink-on-scroll');
    var headerHorizontal = document.querySelector('.header--horizontal');
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (logingButton) {
      logingButton.remove();
    }

    if (registerButton) {
      registerButton.remove();
    }

    if (searchBar && navGroup && searchBar.parentNode !== navGroup) {
      navGroup.insertBefore(searchBar, navGroup.firstChild);
      navGroup.classList.add('header-search-moved');
    }

    if (headerHorizontal) {
      headerHorizontal.style.setProperty('grid-template-columns', 'auto 1fr auto', 'important');

      if (!isMobile) {
        headerHorizontal.style.setProperty('column-gap', '10px', 'important');
      } else {
        headerHorizontal.style.removeProperty('column-gap');
      }

      headerHorizontal.classList.remove('header-adjusting');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustHeader);
  } else {
    adjustHeader();
  }

  window.addEventListener('resize', adjustHeader);
})();

  } catch(e) { console.error(e); }
})();
})();
